// removed by extract-text-webpack-plugin
module.exports = {"myLink":"_2rSB-2Z1voo6tzj9GyQxMm"};


//////////////////
// WEBPACK FOOTER
// ./src/blocks/MyLink/index.css
// module id = 142
// module chunks = 0